export const APP_VERSION = '7.0.0';
